export default "__VITE_ASSET__B$HjVViC__"